import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFullscreen2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"fullscreen-2"} maskId="square-filled-radius-0-stroke-1-IconFullscreen2"><path d="M2 4V20H22V4H2Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFullscreen2;
